<template>
    <div class="withdrawList">
        <div>
            <bread-crumb :bread-list="breadList" />
        </div>
        <div class="info-wrap">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">提现管理</span>
            </div>
            <div class="select-form">
                <div class="show-wrap">
                    <div class="search-show-wrap">
                        <el-input
                            class="search-input"
                            size="small"
                            placeholder="请输入用户姓名"
                            v-model="selectForm.name"
                            @keyup.enter.native="searchOrder('search')"
                        >
                            <i
                                slot="suffix"
                                class="iconfont icon-search"
                                @click="searchOrder('search')"
                            ></i>
                        </el-input>
                        <div
                            class="more-search"
                            @click="isMoreShow=!isMoreShow"
                        >
                            <span class="more-search-text">高级搜索</span>
                            <i
                                class="iconfont icon-drop_down"
                                :class="[{'is-reverse': isMoreShow}]"
                            ></i>
                        </div>
                    </div>
                    <div class="export-btn">
                        <el-button
                            size="small"
                            type="primary"
                            @click="getExcel()"
                        >导出</el-button>
                        <el-tooltip
                            class="item"
                            effect="dark"
                            content="仅导出已审核通过的"
                            placement="top"
                        >
                            <i class="el-icon-warning icon-tip"></i>
                        </el-tooltip>
                    </div>
                </div>
                <div
                    class="hide-wrap"
                    v-if="isMoreShow"
                >
                    <div class="option-wrap">
                        <div class="option-item">
                            <span class="label">提现状态</span>
                            <el-select
                                v-model="selectForm.status"
                                placeholder="请选择"
                                size="small"
                                :style="{width: '240px'}"
                            >
                                <el-option
                                    v-for="(item, index) in statusList"
                                    :key="index"
                                    :label="item.dictDataValue"
                                    :value="item.dictDataCode"
                                >
                                </el-option>
                            </el-select>
                        </div>
                        <div class="option-item">
                            <span class="label">用户来源</span>
                            <el-select
                                v-model="selectForm.origin"
                                placeholder="请选择"
                                size="small"
                                :style="{width: '240px'}"
                            >
                                <el-option
                                    value="all"
                                    label="全部"
                                ></el-option>
                                <el-option
                                    v-for="(item, index) in originList"
                                    :key="index"
                                    :label="item.dictDataValue"
                                    :value="item.dictDataCode"
                                >
                                </el-option>
                            </el-select>
                        </div>
                        <div class="option-item">
                            <span class="label">提现时间</span>
                            <el-date-picker
                                size="small"
                                clearable
                                clear-icon="el-icon-error"
                                v-model="selectForm.buyTime"
                                type="daterange"
                                range-separator="-"
                                start-placeholder="yyyy-mm-dd"
                                end-placeholder="yyyy-mm-dd"
                                value-format="yyyy-MM-dd"
                                :style="{width: '240px'}"
                                @change="handleDateChange"
                                :picker-options="datePickerOptions"
                            ></el-date-picker>
                        </div>
                        <div class="select-btn-wrap">
                            <el-button
                                type="primary"
                                size="small"
                                @click="searchOrder('search')"
                            >查询</el-button>
                            <el-button
                                type="info"
                                size="small"
                                plain
                                @click="searchOrder('reset')"
                            >重置</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-wrap">
                <el-table
                    :data="withdrawList"
                    stripe
                    v-loading="loading"
                    style="width: 100%"
                >
                    <el-table-column
                        prop="name"
                        width="90px"
                        type="index"
                        label="序号"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="userName"
                        min-width="120px"
                        label="用户姓名"
                    >
                        <template slot-scope="scope">
                            {{scope.row.userName || '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="deptName"
                        min-width="120px"
                        label="科室"
                    >
                        <template slot-scope="scope">
                            {{scope.row.departmentName || '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="userSource"
                        min-width="100px"
                        label="用户来源"
                    >
                        <template slot-scope="scope">
                            {{originList.find(type =>type.dictDataCode == scope.row.userSource)
                            ? originList.find(type =>type.dictDataCode == scope.row.userSource).dictDataValue
                            : '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="orderId"
                        min-width="150px"
                        label="提现单号"
                    >
                        <template slot-scope="scope">
                            {{scope.row.orderId || '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="bank"
                        min-width="120px"
                        label="银行"
                    >
                        <template slot-scope="scope">
                            {{scope.row.bank || '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="accountOpeningBranch"
                        min-width="150px"
                        label="开户行"
                    >
                        <template slot-scope="scope">
                            {{scope.row.accountOpeningBranch || '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="idCard"
                        min-width="150px"
                        label="身份证"
                    >
                        <template slot-scope="scope">
                            {{scope.row.idCard || '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="cardNo"
                        min-width="180px"
                        label="银行卡号"
                    >
                        <template slot-scope="scope">
                            {{scope.row.cardNo || '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="phone"
                        min-width="120px"
                        label="手机号"
                    >
                        <template slot-scope="scope">
                            {{scope.row.phone || '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="approvalStatus"
                        min-width="120px"
                        label="审核状态"
                    >
                        <template slot-scope="scope">
                            <span
                                class="circle"
                                :class="{'success': scope.row.approvalStatus=='APPROVED','error': scope.row.approvalStatus=='REFUSE','warn': scope.row.approvalStatus=='REVIEWING'}"
                            ></span>
                            <span>
                                {{statusList.find(type =>type.dictDataCode == scope.row.approvalStatus)
                                ? statusList.find(type =>type.dictDataCode == scope.row.approvalStatus).dictDataValue
                                : '-'}}
                            </span>
                            <span v-if="scope.row.approvalStatus === 'REFUSE'">
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    :content="scope.row.reason"
                                    placement="top"
                                >
                                    <i
                                        class="el-icon-warning"
                                        style="font-size:16px;color:#bebebe;margin-left:6px"
                                    ></i>
                                </el-tooltip>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="withdramAmount"
                        min-width="140px"
                        label="提现金额(元)"
                    >
                        <template slot-scope="scope">
                            {{scope.row.withdramAmount}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="balance"
                        min-width="140px"
                        label="账户余额(元)"
                    >
                        <template slot-scope="scope">
                            {{scope.row.balance}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="payTime"
                        min-width="160px"
                        label="提现时间"
                    >
                        <template slot-scope="scope">
                            {{scope.row.withdramTime || "-"}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="payTime"
                        min-width="160px"
                        label="审核时间"
                    >
                        <template slot-scope="scope">
                            {{scope.row.approvalTime || "-"}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        min-width="160px"
                        fixed="right"
                        label="操作"
                    >
                        <template slot-scope="scope">
                            <div v-if="scope.row.approvalStatus === 'REVIEWING'">
                                <span
                                    class="link-btn"
                                    @click="openPass(scope.row),passVisible = true"
                                >通过</span>
                                <span
                                    class="link-btn"
                                    @click="opennoPass(scope.row),nopassVisible = true"
                                >不通过</span>
                            </div>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <div
                        slot="empty"
                        class="table-none"
                    >
                        <div>
                            <svg-icon icon-class="none1" />
                        </div>
                        <span>暂无数据</span>
                    </div>
                </el-table>
            </div>
            <div class="pagination-wrap">
                <el-pagination
                    background
                    @current-change="pageChange"
                    :current-page.sync="page.current"
                    :page-size="page.pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="page.total"
                ></el-pagination>
            </div>
        </div>

        <!-- 不通过 -->
        <el-dialog
            title="不通过理由"
            :visible.sync="nopassVisible"
            width="450px"
            class="no-pass-dialog"
            v-loading="noPassLoading"
            center
        >
            <el-form :model="nopassForm">
                <el-form-item label-width="80">
                    <el-input
                        type="textarea"
                        maxlength="150"
                        placeholder="请输入不通过理由"
                        v-model="nopassForm.content"
                    ></el-input>
                </el-form-item>
            </el-form>
            <p style="color:#999">建议15字内，理由会发送至用户消息中</p>
            <div
                slot="footer"
                class="dialog-footer"
            >
                <el-button
                    @click="nopassVisible = false"
                    size="mini"
                >取消</el-button>
                <el-button
                    type="primary"
                    @click="handlenoPass"
                    size="mini"
                >确定</el-button>
            </div>
        </el-dialog>
        <!-- 通过 -->
        <el-dialog
            title="通过审核"
            :visible.sync="passVisible"
            width="450px"
            v-loading="passLoading"
            center
        >
            <div
                class="pass-text"
                style="line-height:26px"
            >
                <p>确定审核通过？</p>
                <p>审核通过后，请在7-15个工作日内完成打款</p>
            </div>
            <div
                slot="footer"
                class="dialog-footer"
            >
                <el-button
                    @click="passVisible = false"
                    size="mini"
                >取消</el-button>
                <el-button
                    type="primary"
                    @click="handlePass"
                    size="mini"
                >确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<style lang="scss">
.el-tooltip__popper.is-dark {
    max-width: 400px;
}
.withdrawList {
    .show-wrap {
        .el-button--small {
            width: 86px;
            font-size: 14px;
            padding: 8px 15px;
        }
    }
    .select-btn-wrap {
        font-size: 0;
        .el-button--small {
            width: 80px;
            padding: 8px 15px;
            font-size: 14px;
        }
        .el-button--info.is-plain {
            background: #f5f5f5;
            border-color: #cccccc;
            color: #666;
        }
    }
    .option-item {
        .el-select {
            margin-right: 10px;
            &:last-child {
                margin-right: 0;
            }
        }
    }
    .no-pass-dialog {
        .el-dialog__body {
            padding: 24px 20px 20px;
            .el-form-item {
                margin-bottom: 10px;
                .el-textarea__inner {
                    height: 120px;
                }
            }
        }
    }
    .el-dialog__footer {
        padding-top: 0;
    }
}
</style>
<style lang="scss" scoped>
.info-wrap {
    background-color: #fff;
    box-shadow: 0 1px 4px 0 hsla(0, 0%, 79%, 0.5);
    position: absolute;
    left: 20px;
    right: 20px;
    bottom: 20px;
    top: 50px;
    padding: 20px;
    overflow: auto;
}
.title-wrap {
    font-size: 0;
    padding-bottom: 20px;
    height: 16px;
    line-height: 16px;
    .icon-tongyongbiaotiicon {
        color: $color-primary;
        font-size: 16px;
        vertical-align: middle;
    }
    .title-text {
        font-size: 14px;
        color: #333333;
        margin-left: 10px;
        display: inline-block;
        height: 16px;
        line-height: 16px;
        vertical-align: middle;
    }
}
.show-wrap {
    display: flex;
    justify-content: space-between;
    .search-show-wrap {
        display: flex;
    }
    .more-search {
        font-size: 0;
        color: #666;
        padding-left: 10px;
        cursor: pointer;
    }
    .more-search-text {
        font-size: 14px;
        line-height: 32px;
        padding-right: 3px;
    }
    .export-btn {
        display: flex;
        align-items: center;
        .icon-tip {
            font-size: 20px;
            margin-left: 10px;
            color: #bebebe;
        }
    }
    .icon-drop_down {
        display: inline-block;
        font-size: 12px;
        color: #999;
        transition: transform 0.3s;
        transform: rotateZ(180deg);
        &.is-reverse {
            transform: rotateZ(0deg);
        }
    }
}
.hide-wrap {
    margin-top: 8px;
    background: #f7f7f7;
    border: 1px solid #e6e6e6;
    padding: 20px 0 0 20px;
}

.option-item {
    display: inline-block;
    font-size: 0;
    margin-right: 20px;
    margin-bottom: 20px;
    .label {
        padding-right: 10px;
        font-size: 14px;
        color: #666;
        display: inline-block;
        width: 56px;
        text-align: right;
    }
    &:last-child {
        margin-right: 0;
    }
}
.select-btn-wrap {
    display: inline-block;
    margin-bottom: 20px;
}
.table-wrap {
    margin-top: 20px;
    .table-none {
        height: 400px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .icon {
            font-size: 100px;
        }
        span {
            line-height: 14px;
        }
    }
}
.circle {
    display: inline-block;
    height: 6px;
    width: 6px;
    border-radius: 3px;
    margin-right: 10px;
    &.success {
        background-color: $color-primary-second;
    }
    &.error {
        background-color: $color-danger;
    }
    &.warn {
        background-color: $color-warning;
    }
}
.link-btn {
    cursor: pointer;
    color: $a-link;
    font-size: 12px;
    display: inline-block;
    height: 14px;
    line-height: 14px;
    border-right: 1px solid $a-link;
    margin-right: 10px;
    padding-right: 10px;
    &:last-child {
        border-right: none;
        margin-right: 0;
        padding-right: 0;
    }
}
</style>
<script>
import { mapGetters } from 'vuex'
import shortcuts from '@/utils/pickerOptions'
import { dateToString } from '@/utils/tools'
export default {
    name: 'withdrawList',
    data () {
        return {
            breadList: [{ label: '财务管理' }, { label: '提现管理' }],
            datePickerOptions: {
                shortcuts: shortcuts
            },
            isMoreShow: false,
            selectForm: {
                name: '',
                buyTime: [],
                startTime: '',
                endTime: '',
                status: '',
                origin: ''
            },
            statusList: [],
            originList: [],
            page: {
                current: 1,
                total: 1,
                pageSize: 15
            },
            withdrawList: [],
            loading: true,
            passVisible: false,
            nopassVisible: false,
            selectItem: {},
            nopassForm: {
                content: ''
            },
            noPassLoading: false,
            passLoading: false
        }
    },
    computed: {
        ...mapGetters([
            'dictionary'
        ])
    },
    methods: {
        openPass (item) {
            this.selectItem = item
        },
        opennoPass (item) {
            this.nopassForm.content = ''
            this.selectItem = item
        },
        handlePass () {
            this.passLoading = true
            let row = this.selectItem
            let params = {
                duid: row.duid,
                walletWithdrawId: row.withdrawId
            }
            this.$services.order.getWithdrawApprove(params).then((res) => {
                if (res.results === 'success') {
                    this.$message({
                        message: '已通过',
                        iconClass: 'el-icon-success',
                        duration: '2000'
                    })
                    this.passVisible = false
                    this.passLoading = false
                    this.getData()
                }
            })
        },
        handlenoPass () {
            if (this.nopassForm.content === '') {
                this.$message.error('请填写不通过理由！')
                return
            }
            this.noPassLoading = true
            let row = this.selectItem
            let params = {
                duid: row.duid,
                walletWithdrawId: row.withdrawId,
                reason: this.nopassForm.content
            }
            this.$services.order.getWithdrawRefuse(params).then((res) => {
                if (res.results === 'success') {
                    this.$message({
                        message: '已拒绝通过',
                        iconClass: 'el-icon-success',
                        duration: '2000'
                    })
                    this.nopassVisible = false
                    this.noPassLoading = false
                    this.getData()
                }
            })
        },
        // 导出列表数据
        formatWayJson (filterVal, jsonData) {
            return jsonData.map((v, index) => {
                return filterVal.map((j) => {
                    if (j === 'index') {
                        return (index + 1)
                    } else if (j === 'payTime') {
                        if (v.payTime) {
                            const date = new Date(v.payTime)
                            return dateToString(date, 'yyyy-MM-dd hh:mm')
                        } else {
                            return '-'
                        }
                    } else if (j === 'approvalStatus') {
                        const str = this.statusList.find(status => status.dictDataCode === v.approvalStatus)
                            ? this.statusList.find(status => status.dictDataCode === v.approvalStatus).dictDataValue
                            : '-'
                        return str
                    } else if (j === 'userSource') {
                        const str = this.originList.find(status => status.dictDataCode === v.userSource)
                            ? this.originList.find(status => status.dictDataCode === v.userSource).dictDataValue
                            : '-'
                        return str
                    } else {
                        return v[j] || '-'
                    }
                })
            })
        },
        getExcel () {
            this.page.current = 1
            this.page.pageSize = 1000000
            this.getData('execl')
        },
        handleDateChange (value) {
            if (value) {
                this.selectForm.startTime = value[0] + ' 00:00:00'
                this.selectForm.endTime = value[1] + ' 23:59:59'
            } else {
                this.selectForm.startTime = ''
                this.selectForm.endTime = ''
            }
        },
        searchOrder (type) {
            if (type === 'search') {
                this.page.current = 1
                this.page.pageSize = 15
                this.getData()
            } else if (type === 'reset') {
                this.page.current = 1
                this.page.pageSize = 15
                this.selectForm.startTime = ''
                this.selectForm.endTime = ''
                this.selectForm.status = 'ALL'
                this.selectForm.name = ''
                this.selectForm.origin = ''
                this.selectForm.buyTime = []
                this.getData()
            }
        },
        pageChange (value) {
            this.page.current = value
            this.getData()
        },
        async getData (type) {
            this.loading = true
            const param = {
                current: this.page.current,
                size: this.page.pageSize,
                withdramStartTime: this.selectForm.startTime,
                withdramEndTime: this.selectForm.endTime,
                userSource: this.selectForm.origin === 'all' ? '' : this.selectForm.origin,
                approvalStatus: this.selectForm.status,
                userName: this.selectForm.name
            }
            const { results, total } = await this.$services.order.getWithdrawManagement(param)
            this.withdrawList = results
            this.page.total = total
            this.loading = false
            if (type === 'execl') {
                import('@/vendor/Export2Excel').then(excel => {
                    const tHeader = ['序号', '提现单号', '银行', '开户行', '身份证', '银行卡号', '手机号', '审核状态', '用户姓名', '用户来源', '提现金额(元)', '账户余额(元)', '提现时间', '审核时间', '科室']
                    const filterVal = ['index', 'orderId', 'bank', 'accountOpeningBranch', 'idCard', 'cardNo', 'phone', 'approvalStatus', 'userName', 'userSource', 'withdramAmount', 'balance', 'withdramTime', 'approvalTime', 'departmentName']
                    const list = this.withdrawList.filter((item) => item.approvalStatus === 'APPROVED')
                    // 过滤出已审核的数据列表
                    if (list.length > 0) {
                        const data = this.formatWayJson(filterVal, list)
                        let filename = '提现数据'
                        excel.export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: filename,
                            autoWidth: true,
                            bookType: 'xlsx'
                        })
                    } else {
                        this.$message({
                            message: '无已审核通过数据导出！',
                            type: 'warning',
                            center: true
                        })
                    }
                })
            }
        }
    },
    created () {
        const originList = this.dictionary.USER_SOURCE
        this.originList = originList.filter((item) => item.dictDataCode === 'OUTER' || item.dictDataCode === 'INNER')
        this.statusList = this.dictionary.WALLET_ORDER_STATUS
        // this.selectForm.status = this.statusList && this.statusList.length > 0 ? this.statusList[0].dictDataCode : ''

        if (this.statusList && this.statusList.length > 0) {
            this.selectForm.status = this.statusList[0].dictDataCode
        }
        this.getData()
    }
}
</script>
